
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      // motivation anim
      this.$gsap.set('.icon-grid-img', {
        opacity: 0,
        y: -60,
        scale: 0.9,
      })
      this.$gsap.set('.icon-grid-title', {
        opacity: 0,
        y: -50,
      })
      this.$gsap.set('.icon-grid-text', {
        opacity: 0,
        y: -40,
      })

      this.$ScrollTrigger.batch('.icon-grid-item', {
        // markers: true,
        start: 'center bottom',
        onEnter: (batch) => {
          batch.forEach((card, index) =>
            this.$gsap.to(card.children, {
              opacity: 1,
              y: 0,
              stagger: 0.05,
              delay: index * 0.07,
            })
          )
        },
        once: true,
      })
    },
  },
}
